export default "__VITE_ASSET__ubhLgHFQ__"